__webpack_require__.p = "/wp-content/themes/connaught-theme-child/assets/";